import React, { useState } from 'react';
import SolicitudesRegistro from './SolicitudesRegistro';
import AdminSolicitudesCliente from './AdminSolicitudesCliente';

const TABS = [
  { id: 'empresas', label: 'Solicitudes de empresas', icon: '🏢' },
  { id: 'clientes', label: 'Solicitudes de clientes', icon: '👥' }
];

/**
 * Página unificada de solicitudes de registro: empresas y clientes.
 * Ruta: /admin/solicitudes-registro
 */
export default function SolicitudesRegistroPage() {
  const [tab, setTab] = useState('empresas');

  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h1 className="text-2xl font-bold text-slate-900">Solicitudes de registro</h1>
        <div className="flex rounded-lg border border-slate-200 p-1 bg-slate-50">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                tab === t.id
                  ? 'bg-white text-slate-900 shadow-sm'
                  : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              <span>{t.icon}</span>
              <span>{t.label}</span>
            </button>
          ))}
        </div>
      </div>

      {tab === 'empresas' && <SolicitudesRegistro />}
      {tab === 'clientes' && <AdminSolicitudesCliente />}
    </div>
  );
}
